// extracted by css-extract-rspack-plugin
export default {"container":"container-WvOlX_","divider":"divider-zX8HOG","dividerWide":"dividerWide-MKYXZt"};